<script setup lang="ts">
import { formatCurrencySize } from '~/utils/formatCurrency'
import { useNotificationStore } from '~/store/notification'

//TODO
// empty state cuando no hay datos

defineOptions({
	name: 'LotteryCarousel',
})

const { t: $t } = useI18n()
const notificationStore = useNotificationStore()

const redirectSection = () => {
	const section = document.getElementById('global-lottery-results')
	if (section) {
		section.scrollIntoView({ behavior: 'smooth' })
	}
}
</script>

<template>
	<div
		class="order-first sm:order-last bg-primary-600 sm:bg-primary-500 py-4 overflow-hidden cursor-pointer transition-colors mb-5 sm:mb-0 marquee"
		@click="redirectSection"
	>
		<div class="flex animate-marquee marquee-track">
			<div
				v-for="lottery in notificationStore.getLasLotteries"
				:key="`a-${lottery?.id ?? lottery?.lottery_id ?? lottery?.name ?? 'unknown'}`"
				class="flex items-center gap-2 mx-8 whitespace-nowrap leading-6 text-base font-bold"
			>
				<span class="text-lg">{{ lottery?.flag }}</span>
				<span class="text-white">{{ $t(lottery?.name) }}:</span>
				<span
					v-if="lottery.prize === 0"
					class="text-[#FFDF20]"
				>
					{{ $t('Not winner') }}
				</span>
				<span
					v-else
					class="text-[#FFDF20]"
					>{{ formatCurrencySize(lottery?.prize, lottery?.currency) }}
				</span>
			</div>
			<div
				v-for="lottery in notificationStore.getLasLotteries"
				:key="`b-${lottery?.id ?? lottery?.lottery_id ?? lottery?.name ?? 'unknown'}`"
				class="flex items-center gap-2 mx-8 whitespace-nowrap leading-6 text-base font-bold"
			>
				<span class="text-lg">{{ lottery?.flag }}</span>
				<span class="text-white">{{ $t(lottery?.name) }}:</span>
				<span
					v-if="lottery.prize === 0"
					class="text-neutral-600 text-sm"
				>
					{{ $t('Not winner') }}
				</span>
				<span
					v-else
					class="text-[#FFDF20]"
					>{{ formatCurrencySize(lottery?.prize, lottery?.currency) }}
				</span>
			</div>
		</div>
	</div>
</template>
<style lang="postcss">
.marquee {
	overflow: hidden;
	--duration: 60s;
}

.marquee-track {
	display: flex;
	width: max-content;
	will-change: transform;
	animation: marquee var(--duration) linear infinite;
}

@keyframes marquee {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(-50%);
	}
}

@media (max-width: 640px) {
	.marquee {
		--duration: 40s;
	}
}
</style>
